import React, { useState, useRef, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
  editWatersports,
  getwatersportsList,
} from "../store/slices/waterSports";
import Select from "react-select";

import { nameregex, priceRegex } from "../helper/regex";
import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import JoditEditor from "jodit-react";
import { GrUploadOption } from "react-icons/gr";
import { CiCirclePlus, CiCircleMinus } from "react-icons/ci";
import "react-bootstrap-typeahead/css/Typeahead.css";

const EditWaterSport = () => {
  const { id } = useParams();
  const editor = useRef(null);
  const stripHtmlTags = (html) => {
    return html.replace(/<[^>]*>/g, "").trim();
  };
  let user = JSON.parse(localStorage.getItem("users"));
  const token = user.data.accessToken;

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState([]);
  const [videos, setVideos] = useState([
    { id: Date.now(), mediaLink: "", title: "" },
  ]);
  const [place, setPlace] = useState([
    {
      id: Date.now(),
      placeName: "",
      timings: [],
      pricing: [
        {
          id: Date.now() + 1,
          price: "",
          minPax: "",
          maxPax: "",
          type: "",
        },
      ],
    },
  ]);
  const [isLoading, setIsLoading] = useState(true);
  const [videoErrors, setvideoErrors] = useState([]);
  const [placeErrors, setplaceErrors] = useState([
    {
      placeName: "",
      price: "",
      minPax: "",
      maxPax: "",
      type: "",
      timings: "",
    },
  ]);
  const [imageError, setImageError] = useState("");
  const [errors, setErrors] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const editorConfig = useMemo(
    () => ({
      buttons: [
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "|",
        "align",
        "font",
        "fontsize",
        "paragraph",
        "|",
        "undo",
        "redo",
      ],
      placeholder: "Enter Description",
      removeButtons: ["image", "video", "file", "speech", "print", "preview"],
      readonly: false,
    }),
    [],
  );
  const timeOptions = Array.from({ length: 34 }, (_, i) => {
    const hour = 3 + Math.floor(i / 2); // from 3 to 19 (3 AM to 19 = 7 PM)
    const minute = i % 2 === 0 ? "00" : "30";
    const paddedHour = hour.toString().padStart(2, "0"); // ensure 2 digits
    const label = `${paddedHour}:${minute}`;
    return { value: label, label };
  });

  useEffect(() => {
    const fetchPlaceDetails = async () => {
      try {
        let item = { id };
        const data = await dispatch(getwatersportsList(item)).unwrap();
        const sport = data?.WaterSportsData[0];
        setName(sport.name || "");
        setDescription(sport.description);
        setImage(sport.image || []);

        const clonedVideosDetails = (sport.videos || []).map((item, index) => ({
          ...item,
          id: `${Date.now()}-${index}`,
        }));
        const initialvehicleErrors = clonedVideosDetails.map((item) => ({
          title: "",
          mediaLink: "",
        }));
        setvideoErrors(initialvehicleErrors);
        setVideos(clonedVideosDetails);
        const clonedPlaceDetails =
          sport.place && sport.place.length > 0
            ? sport.place.map((item, index) => ({
                id: `${Date.now()}-${index}`,
                placeName: item.placeName || "",
                timings: item.timings || [],
                pricing:
                  item.pricing && item.pricing.length > 0
                    ? item.pricing.map((p, pIndex) => ({
                        id: `${Date.now()}-${index}-${pIndex}`,
                        price: p.price || "",
                        minPax: p.minPax || "",
                        maxPax: p.maxPax || "",
                        type: p.type || "",
                      }))
                    : [
                        {
                          id: Date.now(),
                          price: "",
                          minPax: "",
                          maxPax: "",
                          type: "",
                        },
                      ],
              }))
            : [
                {
                  id: Date.now(),
                  placeName: "",
                  timings: [],
                  pricing: [
                    {
                      id: Date.now(),
                      price: "",
                      minPax: "",
                      maxPax: "",
                      type: "",
                    },
                  ],
                },
              ];
        const initialplaceErrors = clonedPlaceDetails.map(() => ({
          placeName: "",
          price: "",
          timings: "",
          minPax: "",
          maxPax: "",
          type: "",
        }));
        setplaceErrors(initialplaceErrors);
        setPlace(clonedPlaceDetails);
      } catch (error) {
        console.error("Failed to fetch package details:", error.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPlaceDetails();
  }, [dispatch, id]);

  /** IMAGE UPLOAD **/
  const imageUpload = async (e) => {
    setImageError("");
    const files = Array.from(e.target.files);

    if (files.length === 0) {
      setImageError("Please select at least one file to upload");
      return;
    }
    if (image.length + files.length > 10) {
      setImageError("You can upload a maximum of 10 images");
      return;
    }

    const newImage = [];
    for (let file of files) {
      if (file.size > 5 * 1024 * 1024) {
        setImageError("Please upload image less than 5 MB");
        return;
      }

      const formData = new FormData();
      formData.append("file", file);

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          "x-access-token": token,
        },
      };

      try {
        const response = await fetch(
          `${API_BASE_URL}${API_PATHS.uploadFile}`,
          requestOptions,
        );

        if (!response.ok) {
          throw new Error(`Upload failed with status: ${response.status}`);
        }

        const data = await response.json();

        if (data?.status === 1 && data?.data?.location) {
          newImage.push({
            name: file.name,
            mediaLink: data.data.location,
            isActive: true,
          });
        } else {
          throw new Error(data.message || "Failed to upload image");
        }
      } catch (error) {
        setImageError(
          error.message || "Something went wrong while uploading the image",
        );
        return;
      }
    }

    setImage((prevImage) => [...prevImage, ...newImage]);
    e.target.value = null;
  };

  const removeImage = (index) => {
    setImage((prevImage) => {
      const updatedImage = [...prevImage];
      updatedImage.splice(index, 1);

      if (updatedImage.length === 0) {
        setImageError("Please upload at least one image");
      } else {
        setImageError("");
      }

      return updatedImage;
    });
  };

  const handleAddVideo = (e) => {
    e.preventDefault();
    const newId = Date.now().toString();
    setVideos((prevPlace) => [
      ...prevPlace,
      { id: newId, title: "", mediaLink: "" },
    ]);

    setvideoErrors((prevErrors) => [
      ...prevErrors,
      { title: "", mediaLink: "" },
    ]);
  };

  const handleRemoveVideo = (id, index) => {
    setVideos((prev) => prev.filter((v) => v.id !== id));
    setvideoErrors((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddPlace = (e) => {
    e.preventDefault();
    const newId = Date.now().toString();
    const isDuplicate = place.some((item) => item.placeName === "");
    if (isDuplicate) {
      alert(
        "Please select a place for the existing row before adding a new one.",
      );
      return;
    }

    setPlace((prevPlace) => [
      ...prevPlace,
      {
        id: newId,
        placeName: "",
        timings: [],
        pricing: [
          {
            id: Date.now(),
            price: "",
            minPax: "",
            maxPax: "",
            type: "",
          },
        ],
      },
    ]);

    setplaceErrors((prevErrors) => [
      ...prevErrors,
      {
        placeName: "",
        price: "",
        minPax: "",
        maxPax: "",
        type: "",
        timings: [],
      },
    ]);
  };

  const handleRemovePlace = (id, index) => {
    if (place.length === 1) {
      alert("At least one place must be present.");
      return;
    }

    setPlace((prev) => prev.filter((p) => p.id !== id));
    setplaceErrors((prev) => prev.filter((_, i) => i !== index));
  };

  const handleTimingChange = (index, selectedOptions) => {
    const updatedPlaces = [...place];
    updatedPlaces[index].timings =
      selectedOptions?.map((opt) => opt.value) || [];
    setPlace(updatedPlaces);
  };

  const handleVideoChange = (index, field, value) => {
    const updatedVideos = [...videos];
    const updatedErrors = [...videoErrors];
    if (!updatedErrors[index]) {
      updatedErrors[index] = {
        title: "",
        mediaLink: "",
      };
    }

    if (field === "title") {
      updatedVideos[index][field] = value;
      updatedErrors[index].title =
        value.trim() === "" ? "Please enter title" : "";
    }

    if (field === "mediaLink") {
      updatedVideos[index][field] = value;
      updatedErrors[index].mediaLink =
        value.trim() === "" ? "Please enter video link" : "";
    }
    setvideoErrors([...updatedErrors]);
    setVideos([...updatedVideos]);
  };

  const handlePlaceChange = (index, field, value) => {
    const updatedplace = [...place];
    const updatedErrors = [...placeErrors];

    if (!updatedErrors[index]) {
      updatedErrors[index] = {
        placeName: "",
      };
    }

    if (field === "placeName") {
      updatedplace[index][field] = value;
      updatedErrors[index].placeName =
        value.trim() === "" ? "Please select a place" : "";
    }

    setplaceErrors([...updatedErrors]); // Ensure state updates
    setPlace([...updatedplace]);
  };

  const handleDescriptionChange = (content) => {
    setDescription(content);

    const stripHtmlTags = (html) => {
      const div = document.createElement("div");
      div.innerHTML = html;
      return div.textContent || div.innerText || "";
    };

    setErrors((prevErrors) => ({
      ...prevErrors,
      description:
        stripHtmlTags(content).trim().length === 0
          ? "Please enter valid description"
          : "",
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const validationErrors = { ...errors };

    if (name === "name") {
      setName(value);
      validationErrors.name =
        value.trim() === "" ? "Please enter sport name" : "";
    }

    if (name === "description") {
      setDescription(value);
      validationErrors.description =
        value.trim() === "" ? "Please enter description" : "";
    }
    setErrors(validationErrors);
  };
  const handleAddPricing = (placeIndex) => {
    const updated = [...place];
    updated[placeIndex].pricing.push({
      id: Date.now(),
      price: "",
      minPax: "",
      maxPax: "",
      type: "",
    });
    setPlace(updated);
  };

  const handleRemovePricing = (placeIndex, pricingId) => {
    const updated = [...place];
    if (updated[placeIndex].pricing.length === 1) {
      alert("At least one pricing slab is required.");
      return;
    }
    updated[placeIndex].pricing = updated[placeIndex].pricing.filter(
      (p) => p.id !== pricingId,
    );
    setPlace(updated);
  };

  const handlePricingChange = (placeIndex, pricingIndex, field, value) => {
    const updated = [...place];
    let pricingItem = updated[placeIndex].pricing[pricingIndex];

    if (field === "price")
      pricingItem.price = value.replace(/\D/g, "").slice(0, 6);

    if (field === "minPax")
      pricingItem.minPax = value.replace(/\D/g, "").slice(0, 2);

    if (field === "maxPax")
      pricingItem.maxPax = value.replace(/\D/g, "").slice(0, 2);

    if (field === "type") pricingItem.type = value;

    setPlace(updated);
  };

  const validateForm = () => {
    let newErrors = {};

    if (!name || name.trim() === "") {
      newErrors.name = "Please enter sport name";
    }

    if (!description.trim() || stripHtmlTags(description).length === 0) {
      newErrors.description = "Please enter valid description";
    }

    const videoErrors = videos.map((item) => ({
      title: item.title === "" ? "Please enter video title" : "",
      mediaLink: item.mediaLink.trim() === "" ? "Please enter video link" : "",
    }));

    setvideoErrors(videoErrors);

    if (videoErrors.some((err) => err.title || err.mediaLink)) {
      newErrors.video = "Please fix errors in the video section";
    }

    const newPlaceErrors = place.map((item) => {
      let pricingError = "";

      // Must have pricing array
      if (!item.pricing || item.pricing.length === 0) {
        pricingError = "At least one pricing slab is required";
      } else {
        // Fully valid slabs
        const validSlabs = item.pricing.filter(
          (p) =>
            p.price &&
            p.minPax &&
            p.maxPax &&
            p.type &&
            Number(p.minPax) <= Number(p.maxPax),
        );

        // No valid slab
        if (validSlabs.length === 0) {
          pricingError = "At least one valid pricing slab must be filled";
        }

        // Partial slab detection
        const hasPartial = item.pricing.some(
          (p) =>
            (p.price || p.minPax || p.maxPax || p.type) &&
            (!p.price || !p.minPax || !p.maxPax || !p.type),
        );

        if (hasPartial) {
          pricingError = "Please complete all pricing slab fields";
        }
      }

      return {
        placeName: item.placeName === "" ? "Please select place" : "",
        timings:
          !Array.isArray(item.timings) || item.timings.length === 0
            ? "Please select at least one timing"
            : "",
        pricing: pricingError,
      };
    });

    setplaceErrors(newPlaceErrors);

    if (
      newPlaceErrors.some((err) => err.placeName || err.pricinng || err.timings)
    ) {
      newErrors.place = "Please fix errors in the place section";
    }

    setErrors(newErrors);

    const isValid =
      Object.keys(newErrors).length === 0 &&
      videoErrors.every((err) => !err.title && !err.mediaLink) &&
      newPlaceErrors.every(
        (err) => !err.placeName && !err.timings && !err.pricing,
      );

    return isValid;
  };
  const addPlaces = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      console.log("Validation failed, please fix the errors.", errors);
      return;
    }
    setIsDisabled(true);
    setTimeout(() => setIsDisabled(false), 3000);

    const item = {
      name,
      id,
      status: 1,
      description,
      image,
      videos,
      place,
    };

    try {
      await dispatch(editWatersports(item)).unwrap();
      navigate("/admin/watersports");
      alert("Water Sport added successfully!");
    } catch (error) {
      alert(error);
    }
  };

  const cancel = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Add Water Sport</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/watersports"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Water Sports
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Add Water Sport</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form onSubmit={addPlaces}>
            <div className="row mb-40">
              <div className="col-md-5">
                <label className="form-label">
                  Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={name}
                  onChange={handleChange}
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                  placeholder="Enter Water Sport Name"
                />
                {errors.name && (
                  <div className="text-danger mt-2">{errors.name}</div>
                )}
              </div>

              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Images <span className="text-danger">*</span>
                </label>
                <br />
                <label htmlFor="fileInput" className="custom-button">
                  <GrUploadOption
                    style={{ fontSize: "16px", lineHeight: "18px" }}
                  />
                  &nbsp; Upload Image
                </label>
                <input
                  type="file"
                  id="fileInput"
                  name="image"
                  accept="image/*"
                  onChange={imageUpload}
                  className={`form-control ${imageError ? "is-invalid" : ""}`}
                  multiple
                />

                {imageError && (
                  <div className="text-danger mt-2">{imageError}</div>
                )}
                <div className="row mt-3">
                  {image.map((img, index) => (
                    <div
                      className="col-md-4 mb-2 position-relative"
                      key={index}
                    >
                      <img
                        src={img.mediaLink}
                        style={{ height: "120px", objectFit: "cover" }}
                        alt=""
                        className="img-thumbnail"
                      />
                      <button
                        className="image-remove-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          removeImage(index);
                        }}
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Description <span className="text-danger">*</span>
                </label>

                <JoditEditor
                  ref={editor}
                  value={description}
                  config={editorConfig}
                  onBlur={handleDescriptionChange}
                />
                {errors.description && (
                  <div className="text-danger mt-2">{errors.description}</div>
                )}
              </div>

              {/* Videos Section */}
              <div className="col-md-10 mt-3">
                <label className="form-label">Videos</label>
                {videos.map((item, index) => (
                  <div
                    key={item.id}
                    className="container border p-3 mb-3 rounded"
                  >
                    <div className="d-flex justify-content-end mb-2">
                      <button
                        className="btn btn-primary-600 me-2"
                        style={{
                          height: "30px",
                          width: "30px",
                          padding: "0",
                        }}
                        onClick={handleAddVideo}
                      >
                        <CiCirclePlus style={{ fontSize: "25px" }} />
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-primary-600"
                        style={{
                          height: "30px",
                          width: "30px",
                          padding: "0",
                        }}
                        onClick={() => handleRemoveVideo(item.id, index)}
                      >
                        <CiCircleMinus style={{ fontSize: "25px" }} />
                      </button>
                    </div>
                    <div className="row mt-3">
                      <div className="col-md-6">
                        <label className="form-label">
                          Video Title <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="title"
                          value={item.title}
                          onChange={(e) =>
                            handleVideoChange(index, "title", e.target.value)
                          }
                          placeholder="Video Title"
                          className={`form-control ${
                            videoErrors[index]?.title ? "is-invalid" : ""
                          }`}
                        />
                        {videoErrors[index]?.title && (
                          <span className="error-message">
                            {videoErrors[index]?.title}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">
                          Video Link <span className="text-danger">*</span>
                        </label>
                        <input
                          type="url"
                          name="mediaLink"
                          value={item.mediaLink}
                          onChange={(e) =>
                            handleVideoChange(
                              index,
                              "mediaLink",
                              e.target.value,
                            )
                          }
                          placeholder="Video URL"
                          className={`form-control ${
                            videoErrors[index]?.mediaLink ? "is-invalid" : ""
                          }`}
                        />
                        {videoErrors[index]?.mediaLink && (
                          <span className="error-message">
                            {videoErrors[index]?.mediaLink}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Places Section */}
              <div className="col-md-10 mt-3">
                <label className="form-label">Places</label>
                <div className="question-form"></div>
                {place.map((p, index) => (
                  <div key={p.id} className="container border p-3 mb-3 rounded">
                    <div className="d-flex justify-content-end mb-2">
                      <button
                        type="button"
                        className="btn btn-primary-600 me-2"
                        style={{
                          height: "30px",
                          width: "30px",
                          padding: "0",
                        }}
                        onClick={handleAddPlace}
                      >
                        <CiCirclePlus style={{ fontSize: "25px" }} />
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-primary-600"
                        style={{
                          height: "30px",
                          width: "30px",
                          padding: "0",
                        }}
                        onClick={() => handleRemovePlace(p.id, index)}
                      >
                        <CiCircleMinus style={{ fontSize: "25px" }} />
                      </button>
                    </div>

                    <div className="row mt-3">
                      <div className="col-md-3">
                        <label className="form-label">
                          Place <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="placeName"
                          value={p.placeName}
                          onChange={(e) =>
                            handlePlaceChange(
                              index,
                              "placeName",
                              e.target.value,
                            )
                          }
                          placeholder="Place Name"
                          className={`form-control ${
                            placeErrors[index]?.placeName ? "is-invalid" : ""
                          }`}
                        />
                        {placeErrors[index]?.placeName && (
                          <div className="text-danger mt-2">
                            {placeErrors[index]?.placeName}
                          </div>
                        )}
                      </div>

                      <div className="col-md-9">
                        <label className="form-label">
                          Timing <span className="text-danger">*</span>
                        </label>
                        <Select
                          isMulti
                          options={timeOptions}
                          value={timeOptions.filter((t) =>
                            p.timings?.includes(t.value),
                          )}
                          onChange={(selected) =>
                            handleTimingChange(index, selected)
                          }
                          classNamePrefix="select"
                          placeholder="Select time slots"
                        />
                        {placeErrors[index]?.timings && (
                          <div className="text-danger mt-2">
                            {placeErrors[index]?.timings}
                          </div>
                        )}
                      </div>
                      <div className="col-md-12 mt-3">
                        <label className="form-label">
                          Pricing Slabs <span className="text-danger">*</span>
                        </label>
                        {placeErrors[index]?.pricing && (
                          <div className="text-danger mt-2">
                            {placeErrors[index]?.pricing}
                          </div>
                        )}
                        {p.pricing.map((priceItem, pricingIndex) => (
                          <div
                            key={priceItem.id}
                            className="border p-3 mb-3 rounded"
                          >
                            <div className="d-flex justify-content-end mb-2">
                              <button
                                type="button"
                                style={{
                                  height: "30px",
                                  width: "30px",
                                  padding: "0",
                                }}
                                className="btn btn-sm btn-primary me-2"
                                onClick={() => handleAddPricing(index)}
                              >
                                <CiCirclePlus style={{ fontSize: "22px" }} />
                              </button>
                              <button
                                type="button"
                                style={{
                                  height: "30px",
                                  width: "30px",
                                  padding: "0",
                                }}
                                className="btn btn-sm btn-outline-danger"
                                onClick={() =>
                                  handleRemovePricing(index, priceItem.id)
                                }
                              >
                                <CiCircleMinus style={{ fontSize: "22px" }} />
                              </button>
                            </div>

                            <div className="row">
                              <div className="col-md-3">
                                <label className="form-label">
                                  Type<span className="text-danger">*</span>
                                </label>
                                <select
                                  className="form-select"
                                  value={priceItem.type}
                                  onChange={(e) =>
                                    handlePricingChange(
                                      index,
                                      pricingIndex,
                                      "type",
                                      e.target.value,
                                    )
                                  }
                                >
                                  <option value="">Select</option>
                                  <option value="PER_PERSON">Per Person</option>
                                  <option value="TOTAL">Total</option>
                                </select>
                              </div>

                              <div className="col-md-3">
                                <label className="form-label">
                                  Price <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Price"
                                  value={priceItem.price}
                                  onChange={(e) =>
                                    handlePricingChange(
                                      index,
                                      pricingIndex,
                                      "price",
                                      e.target.value,
                                    )
                                  }
                                />
                              </div>

                              <div className="col-md-3">
                                <label className="form-label">
                                  Min Pax<span className="text-danger">*</span>
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Min Pax"
                                  value={priceItem.minPax}
                                  onChange={(e) =>
                                    handlePricingChange(
                                      index,
                                      pricingIndex,
                                      "minPax",
                                      e.target.value,
                                    )
                                  }
                                />
                              </div>

                              <div className="col-md-3">
                                <label className="form-label">
                                  Max Pax <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Max Pax"
                                  value={priceItem.maxPax}
                                  onChange={(e) =>
                                    handlePricingChange(
                                      index,
                                      pricingIndex,
                                      "maxPax",
                                      e.target.value,
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              <button
                type="button"
                className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
                onClick={cancel}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md"
                disabled={isDisabled}
              >
                {isDisabled ? "Saving..." : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditWaterSport;
